import moment from 'moment';
import { Button } from 'primereact/button';
import Tag from '../../../../components/Display/Tag';
import { getConstant } from '../../../../utils/constants';
import { getImage } from '../../../../utils/imageHelper';
import { Star } from 'lucide-react';
import styles from "../../cards.module.scss"

function NewsItem({ news, handleClickNews, handleDuplicateNews, layout }) {
  return (
    <div
      className={`${styles.projectCard} ${layout === "grid" ? styles.projectCardGrid : ''}`}
      onClick={handleClickNews}>
      <img
        className={styles.projectImage}
        src={news.image ? news.image.file : getImage('img-ph.png')}
        alt={news.image ? news.image.label : 'Non renseignée'}
      />
      <div className={styles.contentContainer}>
        <div className={styles.topInfo}>
          <p className={styles.title}>{news.title}</p>
          <span className={styles.subtitle}>
            {moment(news.publication_date).format('LL')}
          </span>
        </div>
        <div className={styles.tagList}>
          <Tag
            tag={{
              label: getConstant('bassecour.newsTypes', news.type).label,
              icon: Star,
              bgColor: 'bg-sky-950'
            }}
          />
        </div>
      </div>
      <Button
        rounded
        icon="pi pi-clone"
        className={styles.button}
        tooltip="Dupliquer l'article"
        tooltipOptions={{ position: 'left' }}
        onClick={handleDuplicateNews}
        severity="secondary"
        outlined
      />
    </div >
  );
}

export default NewsItem;
